import React from "react";
import { Grid, makeStyles } from "@material-ui/core";

export default function SectionHeader(props) {
  const { title, color } = props;

  const useStyles = makeStyles({
    root: {
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
    labelStyle: {
      fontFamily: "Roboto",
      fontSize: "14px",
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: 1.33,
      letterSpacing: "normal",
      textAlign: "left",
      color: color ? color : "#212121",
      marginBottom: "0.25rem",
      marginLeft: "0.25rem",
    },
  });
  const classes = useStyles();
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <label className={classes.labelStyle}>{title}</label>
      </Grid>
    </Grid>
  );
}
